import type { SVGProps } from "react";
const SvgNumber10 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    fillRule="evenodd"
    stroke="black"
    strokeWidth={0.501}
    strokeLinejoin="bevel"
    strokeMiterlimit={10}
    fontFamily="Times New Roman"
    fontSize={16}
    style={{
      fontVariantLigatures: "none",
    }}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlns="http://www.w3.org/2000/svg"
    overflow="visible"
    width="68.971pt"
    height="76.88pt"
    viewBox="124.378 -417.755 68.971 76.88"
    {...props}
  >
    <defs />
    <g id="Board Elements" transform="scale(1 -1)">
      <g
        id="Group"
        fillRule="nonzero"
        strokeLinejoin="round"
        strokeLinecap="round"
        stroke="none"
        strokeWidth={0.416}
      >
        <g id="Group_1">
          <g id="Group_2">
            <g id="Group_3" fill="#262626">
              <g id="Group_4">
                <path
                  d="M 132.25,408.062 C 132.669,408.312 133.132,408.47 133.64,408.537 L 147.154,410.325 C 147.471,410.367 147.74,410.289 147.959,410.093 C 148.179,409.896 148.278,409.634 148.257,409.309 L 148.877,343.93 C 148.855,343.604 148.748,343.315 148.555,343.064 C 148.363,342.812 148.108,342.666 147.791,342.624 L 134.657,340.886 C 134.34,340.844 134.071,340.922 133.852,341.118 C 133.632,341.315 133.533,341.577 133.554,341.902 L 133.099,392.875 C 133.057,393.192 132.909,393.334 132.655,393.3 L 125.758,392 C 125.06,391.908 124.697,392.215 124.668,392.921 L 124.379,403.148 C 124.358,403.791 124.653,404.249 125.262,404.523 L 132.25,408.062 Z"
                  markerStart="none"
                  markerEnd="none"
                />
                <path
                  d="M 172.416,344.72 C 167.276,344.04 163.014,345.025 159.629,347.676 C 156.244,350.327 154.211,354.222 153.53,359.361 C 153.446,359.996 153.367,361.083 153.292,362.622 L 153.008,391.829 C 152.971,397.957 154.66,403.119 158.074,407.315 C 161.489,411.511 166.052,413.987 171.762,414.743 C 176.901,415.423 181.161,414.453 184.542,411.834 C 187.923,409.215 189.954,405.336 190.635,400.197 C 190.828,398.737 190.911,397.619 190.885,396.84 L 191.17,367.634 C 191.215,361.442 189.528,356.264 186.109,352.1 C 182.69,347.935 178.126,345.475 172.416,344.72 Z M 172.326,358.556 C 173.405,358.698 174.258,359.328 174.885,360.443 C 175.512,361.559 175.843,362.959 175.878,364.642 L 175.532,395.777 C 175.553,396.103 175.522,396.583 175.438,397.218 C 175.27,398.487 174.884,399.452 174.28,400.115 C 173.676,400.777 172.898,401.045 171.946,400.92 C 170.804,400.768 169.919,400.135 169.293,399.019 C 168.666,397.903 168.366,396.508 168.394,394.833 L 168.645,363.685 C 168.615,363.423 168.638,363.006 168.714,362.435 C 168.882,361.166 169.288,360.171 169.932,359.449 C 170.577,358.728 171.375,358.43 172.326,358.556 Z"
                  markerStart="none"
                  markerEnd="none"
                />
              </g>
            </g>
            <g id="Group_5" fill="#f7e5c5">
              <g id="Group_6">
                <path
                  d="M 134.428,410.864 C 134.847,411.114 135.31,411.272 135.818,411.339 L 149.332,413.127 C 149.649,413.169 149.918,413.091 150.137,412.895 C 150.357,412.698 150.456,412.436 150.435,412.111 L 151.055,346.731 C 151.033,346.406 150.926,346.117 150.733,345.866 C 150.541,345.614 150.286,345.468 149.969,345.426 L 136.835,343.688 C 136.518,343.646 136.249,343.724 136.03,343.92 C 135.81,344.117 135.711,344.379 135.732,344.704 L 135.277,395.677 C 135.235,395.994 135.087,396.136 134.833,396.102 L 127.936,394.802 C 127.238,394.71 126.875,395.017 126.846,395.723 L 126.557,405.95 C 126.536,406.593 126.831,407.051 127.44,407.325 L 134.428,410.864 Z"
                  markerStart="none"
                  markerEnd="none"
                />
                <path
                  d="M 174.594,347.522 C 169.454,346.842 165.192,347.827 161.807,350.478 C 158.422,353.129 156.389,357.024 155.708,362.163 C 155.624,362.798 155.545,363.885 155.47,365.424 L 155.186,394.631 C 155.149,400.759 156.838,405.921 160.252,410.117 C 163.667,414.313 168.23,416.789 173.94,417.545 C 179.079,418.225 183.339,417.255 186.72,414.636 C 190.101,412.017 192.132,408.138 192.813,402.999 C 193.006,401.539 193.089,400.421 193.063,399.642 L 193.348,370.436 C 193.393,364.244 191.706,359.066 188.287,354.902 C 184.868,350.737 180.304,348.277 174.594,347.522 Z M 174.504,361.358 C 175.583,361.5 176.436,362.13 177.063,363.245 C 177.69,364.361 178.021,365.761 178.056,367.444 L 177.71,398.579 C 177.731,398.905 177.7,399.385 177.616,400.02 C 177.448,401.289 177.062,402.254 176.458,402.917 C 175.854,403.579 175.076,403.847 174.124,403.722 C 172.982,403.57 172.097,402.937 171.471,401.821 C 170.844,400.705 170.544,399.31 170.572,397.635 L 170.823,366.487 C 170.793,366.225 170.816,365.808 170.892,365.237 C 171.06,363.968 171.466,362.973 172.11,362.251 C 172.755,361.53 173.553,361.232 174.504,361.358 Z"
                  markerStart="none"
                  markerEnd="none"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export default SvgNumber10;
